export const PRICES = {
  "Normal Polish": 20,
  "Gel": 30,
  "Poly Gel": 40,
  "Acrylic": 40,
  "Specialized Design": "Please call for pricing"
};
